import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Mail, MapPin, Phone, Instagram, Facebook, Twitter } from "lucide-react";
import api from "@/lib/api";
import { LogoFull } from "@/components/Logo";

export function Footer() {
  const { t } = useTranslation();
  const [info, setInfo] = useState(null);
  useEffect(() => { api.get("/contact-info").then((r) => setInfo(r.data)).catch(() => {}); }, []);
  return (
    <footer className="bg-[#0D1F1F] text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="space-y-4">
          <LogoFull light />
          <p className="text-pastel/80 text-sm font-body max-w-xs">{t("footer.tagline")}</p>
          <div className="flex gap-3">
            {[Instagram, Facebook, Twitter].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-emeraude transition-colors" data-testid={`footer-social-${i}`}>
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <h4 className="font-heading font-bold mb-4 text-emeraude">{t("footer.quickLinks")}</h4>
          <ul className="space-y-2 text-sm font-body text-pastel/80">
            <li><Link to="/search" className="hover:text-white">{t("nav.vehicles")}</Link></li>
            <li><Link to="/about" className="hover:text-white">{t("nav.about")}</Link></li>
            <li><Link to="/faq" className="hover:text-white">{t("nav.faq")}</Link></li>
            <li><Link to="/register?role=loueur" className="hover:text-white">{t("nav.loueur")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-bold mb-4 text-emeraude">{t("footer.legal")}</h4>
          <ul className="space-y-2 text-sm font-body text-pastel/80">
            <li><Link to="/legal" className="hover:text-white">{t("footer.legal")}</Link></li>
            <li><Link to="/legal" className="hover:text-white">{t("footer.terms")}</Link></li>
            <li><Link to="/legal" className="hover:text-white">{t("footer.privacy")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-bold mb-4 text-emeraude">{t("footer.contact")}</h4>
          <ul className="space-y-2 text-sm font-body text-pastel/80">
            {info?.email && <li className="flex items-center gap-2"><Mail className="w-4 h-4" /> <a href={`mailto:${info.email}`} className="hover:text-white" data-testid="footer-email">{info.email}</a></li>}
            {info?.phone && <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> <a href={`tel:${info.phone.replace(/\s/g, "")}`} className="hover:text-white">{info.phone}</a></li>}
            {info?.address && <li className="flex items-center gap-2"><MapPin className="w-4 h-4" /> {info.address}</li>}
            <li className="pt-2 text-emeraude font-semibold">{t("footer.currency")}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-pastel/60 font-body">
        © {new Date().getFullYear()} Caribbean Drive. {t("footer.rights")}.
      </div>
    </footer>
  );
}
